module.exports = __webpack_public_path__ + "static/media/image_5.31d90035.png";